import Vue from 'vue';
import VueI18n from 'vue-i18n';

import { set, assign } from 'lodash';
import { locales } from 'data/locales';
import { ls } from 'services';
import * as KEYS from 'constants/keys';

import ElementUI from 'element-ui';
import enLocale from 'data/element-ui/lang/en';
import esLocale from 'data/element-ui/lang/es';

// import VueMoment from 'vue-moment';

Vue.use(VueI18n);

const locale = ls.get(KEYS.PREFERRED_LANGUAGE) || KEYS.DEFAULT_LANGUAGE;

// init moment
const moment = require('moment');

require('moment/locale/es');
require('moment/locale/sr');

moment.locale(locale);

Vue.use(require('vue-moment'), {
  moment,
});

const translations = {};

Object.keys(locales).forEach((lang) => {
  set(translations, lang, locales[lang]);
});

// Element en language
assign(translations.en, enLocale);
assign(translations.sr, enLocale);
assign(translations.es, esLocale);

const dateTimeFormats = {
  es: {
    short: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
  sr: {
    short: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
  en: {
    short: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    },
  },
};

const i18n = new VueI18n({
  locale,
  dateTimeFormats,
  fallbackLocale: KEYS.DEFAULT_LANGUAGE,
  messages: translations,
});

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value),
});

Vue.prototype.$locale = {
  change(lang) {
    ls.set(KEYS.PREFERRED_LANGUAGE, lang);
    i18n.locale = lang;
    moment.locale(lang);
  },
  current() {
    return i18n.locale;
  },
  default() {
    return KEYS.DEFAULT_LANGUAGE;
  },
};

export default i18n;



// WEBPACK FOOTER //
// ./src/init/i18n.js